<template>
	<div class="contactus">
		
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>联系我们</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="connect">
						<h3 style="">联系我们</h3>
						<p v-if="describe">{{describe}}</p>
						<p>地址：{{address}}</p>
						<p>联系电话：{{phone}}</p>
						<p v-if="email">Email：{{email}}</p>
					</div>
					<div class="map">
						<baidu-map class="bm-view" :center="point" :zoom="15" :ak="ak">
							<bm-marker :position="point" :dragging="true" @click="infoWindowOpen">
						      	<bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">{{title}}</bm-info-window>
						      	<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
						    </bm-marker>
  						</baidu-map>
					</div>
				</div>
				
				<div style="clear:both;"></div>
			</div>
			
	
		
	</div>
</template>
<script>
import {BaiduMap,BmMarker,BmInfoWindow,BmNavigation} from 'vue-baidu-map'
export default {
	name:'',
	components: {
    	BaiduMap,
    	BmMarker,
    	BmInfoWindow,
    	BmNavigation
  	},
	data(){
		return{
			banner:'',
			show: true,
			ak:'Q84C31uG00CN2srjoCCzlcxyGaC5YVGt',
			point:{
				lng: 116.404, 
				lat: 39.915
			},
			title:'',
			describe:'',
			address:'',
			email:'',
			phone:'',
		}
	},
	methods:{
		getSetting(){
			this.axios({
				method: 'get',
				url: this.GLOBAL.getInfoApi,
				data: {},
			})
			.then((res) => {
				this.point = res.data.data.geographic;
				this.title = res.data.data.siteName;
				this.address = res.data.data.address;
				this.phone = res.data.data.phone;
				this.email = res.data.data.email;
				this.describe = res.data.data.describe;
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getBanner(){
			this.axios({
				method: 'get',
				url: this.GLOBAL.getBannerApi+'7',
				data: {},
			})
			.then((res) => {
				this.banner = res.data.data.banner7;
			})
			.catch((err) => {
				console.log(err)
			})
		},
		infoWindowClose () {
	      	this.show = false
	    },
	    infoWindowOpen () {
	      	this.show = true
	    }
	},
	created(){
		this.getBanner();
		this.getSetting();
	}

}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.contactus{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding(10,10,10,10);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(50);
			.connect{
				.padding(10,50,10,50);
				h3{
					.margin-top(10);
					.margin-bottom(10);
					.font-size(35);
					font-weight: 600;
					color: #2e3b4e;
				}
				p{
					.margin-top(10);
					.margin-bottom(10);
					.font-size(30);
					color:#5f6a7d;
				}
			}
			.map{
				.height(500);
			}
		}
	}
	
	.bm-view {
	  width: 100%;
	  height: 100%;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ContactUs/ContactUs.vue